import React from 'react';
import {connectStateResults} from 'react-instantsearch-dom';

const SearchHits = connectStateResults(({searchState, searchResults, isSearchStalled, children}) => {
  const hasQuery = searchState && searchState.query;
  const hasResults = searchResults && searchResults.nbHits;

  if (!hasQuery) {
    return <div className="no-results">Start searching to see items.</div>;
  }

  if (isSearchStalled) {
    return <div className="no-results">Searching</div>;
  }

  if (hasQuery && !hasResults) {
    return <div className="no-results">No results</div>;
  }

  return children;
});

export default SearchHits;
